<!--
================================================
Un composant qui affiche une ligne de tableau d'un timerecord
(enfant du MyRecentActivityComp)

// @deprecated @since 0.30.1

(visible sur http://localhost:8080/fr/cronocloud-inc/timeclock)
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template class="TimerecordTableLineComp">

    <!-- ------------------------------------------>
    <!--    Timerecord de type isTask-->
    <!-- ------------------------------------------>
    <tr v-bind:class="'detailTr_'+timerecord.slug" v-if="timerecord.isTask == true">
        <td class="taskName">
            <span>
<!--                <font-awesome-icon :icon="['fas', 'sign-in-alt']" class="icon" />-->
                <span class="time">{{timerecord.taskName}}</span>
            </span>
        </td>

        <td class="timeIn">
            <span v-bind:title="$t('dateDentrée', {date: $moment(timerecord.timeIn).format('LLLL') })">
                <font-awesome-icon :icon="['fas', 'sign-in-alt']" class="icon" />
                <span class="time">{{timeIn}}</span>
            </span>
        </td>

        <td class="timeOut">
            <span v-if="timerecord.timeOut!==null" v-bind:title="$t('dateDeSortie', {date: $moment(timerecord.timeOut).format('LLLL') })">
                <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="icon" />
                <span class="time">{{timeOut}}</span>
            </span>
            <span class="encours" v-else>{{$t('encours...')}}</span>
        </td>

        <td class="duration">
            <span v-if="timerecord.timeOut!==null" v-bind:title="$t('durée')">
                <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon"/>
                <span class="">{{duration}}</span>
            </span>

        </td>

        <td class="ipaddress is-hidden-mobile">
            <span v-bind:title="$t('adresseIp')">
                <font-awesome-icon :icon="['fas', 'desktop']" class="icon" />
                <span class="time">{{timerecord.ipAddress}}</span>
            </span>
        </td>

        <td class="trEdit" v-bind:class="'tr_'+ timerecord.slug">
            <a v-if="timerecord.timeOut != null" v-on:click="openModalTrEdit(timerecord)" v-bind:title="$t('modifierLePointage')" class="editIcon is-pulled-right">
                <font-awesome-icon class="icon" :icon="['fas', 'pencil-alt']"/>

            </a>
        </td>

    </tr>

    <!-- ------------------------------------------>
    <!--    Timerecord -->
    <!-- ------------------------------------------>

    <tr v-bind:class="'detailTr_'+timerecord.slug" v-else>
        <td class="timeIn">
            <span v-bind:title="$t('dateDentrée', {date: $moment(timerecord.timeIn).format('LLLL') })">
                <font-awesome-icon :icon="['fas', 'sign-in-alt']" class="icon" />
                <span class="time">{{timeIn}}</span>
            </span>
        </td>

        <td class="timeOut">
            <span v-if="timerecord.timeOut!==null" v-bind:title="$t('dateDeSortie', {date: $moment(timerecord.timeOut).format('LLLL') })">
                <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="icon" />
                <span class="time">{{timeOut}}</span>
            </span>
            <span class="encours" v-else>{{$t('encours...')}}</span>
        </td>

        <td class="duration">
            <span v-if="timerecord.timeOut!==null" v-bind:title="$t('durée')">
                <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon"/>
                <span class="">{{duration}}</span>
            </span>

        </td>

        <td class="ipaddress is-hidden-mobile">
            <span v-bind:title="$t('adresseIp')">
                <font-awesome-icon :icon="['fas', 'desktop']" class="icon" />
                <span class="time">{{timerecord.ipAddress}}</span>
            </span>
        </td>

        <td class="trEdit" v-bind:class="'tr_'+ timerecord.slug">
            <a v-if="timerecord.timeOut != null" v-on:click="openModalTrEdit(timerecord)" v-bind:title="$t('modifierLePointage')" class="editIcon is-pulled-right">
                <font-awesome-icon class="icon" :icon="['fas', 'pencil-alt']"/>

            </a>
        </td>

    </tr>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import TimeMixin from "../mixins/TimeMixin.js";

    export default {
        name: 'TimerecordTableLineComp', //utile dans vue dev tool
        mixins: [TimeMixin],
        // components: {},
        props: ['timerecord'],

        data: function () {
            return {

                locale : this.$route.params.locale,

                // pour les composants où l'user est identifié ///////////////////////
                // organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug)
                // componentIsReady : false, // indique quand le composant est prêt à être afficher
                // =================================================================
            }
        },
        computed:{
            ...mapState({
                user: state => state.user
            }),


            timeIn: {
                get: function () {
                    return this.$moment(this.timerecord.timeIn).tz(this.user.timezone).format('LT')
                },
            },
            timeOut: {
                get: function () {
                    return this.$moment(this.timerecord.timeOut).tz(this.user.timezone).format('LT')
                },
            },

            duration: {
                get: function () {
                    let duration = this.calculateDuration(this.$moment, this.timerecord.timeIn, this.timerecord.timeOut)

                    return this.formatDuration(duration,this.$moment, this.locale)
                },
            }


        },


        methods: {
            /**
             * Ouvre la Modal d'édition d'un timerecord et prépare le timerecord dans le store
             * @param timerecord
             */
            openModalTrEdit: function (timerecord) {
                this.$store.commit('UpdateModalTimerecordsEditionComp',{isVisible: true, timerecord: timerecord})

            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/


    .icon{
        padding-top: 8px; // corrige alignement vertical
    }
    .time{
        /*font-weight: bold;*/
    }
    .icon{
        margin-right: 0.4rem;
        /*border: darkgrey solid 1px;*/
        vertical-align: center;
        padding-top: 0px;
        $size: 0.9rem;
        width: $size;
        height: $size;
    }
    .taskName {
        color: $brandBlue;
        font-weight: bold;

    }
    .timeIn{
        .icon{
            color:$brandPrimary
        }
    }
    .timeOut{
        .icon{
            color: $brandRed
        }

    }
    .duration{

        .icon{
            color: #e2e6e7;
        }
    }

    .ipaddress{
        color: #e2e6e7;
        font-weight: bold;
    }
    .encours{
        color: #ccc;
        font-weight: bold;
    }

    td.trEdit{
        padding: 0 2rem 0; // pour la case d'édition on reset le padding td bulma par défaut
        /*background: red;*/

        .editIcon{

            display: block;
            margin-top: 0.6rem;
            $size: 2.1rem;

            width: $size; height: $size;
            border-radius: 2rem;
            background: #f9f9f9;
            cursor: pointer;

            &:hover{
                .icon{
                    color: $brandFourth
                }
            }
            &:active{
                .icon{
                    color: $brandBlue
                }
            }

            .icon{
                margin-left: 0.6rem;
                margin-top: 0.5rem;
                color:#ced2d4;
                $size: 1rem;
                width: $size; height: $size;
                transition: color 100ms;

            }
        }

    }
</style>
